module.exports = __webpack_public_path__ + "static/cosygsheep1-1424ef5d9cd183b5eba88024e73dff0d.jpeg";